module.exports = __webpack_public_path__ + "img/symbol_8.5a77a1f5.png";